import { IProductCriteriaInfo } from "types";
import { WaitingListLeadState } from "../types/enums";
import { getModalTextsByProductType } from "../utils";
import GenericInformationTable, {
    TableRow
} from "components/ui/table/GenericInformationTable";

interface WaitingListLeadProductCriteriaInformationTableV1Props {
    waitingListLeadCriteriaInfo: {
        waitingListLeadState: WaitingListLeadState;
        isClosedByClient: boolean;
        isPersonalProduct: boolean;
        productCriteriaList: IProductCriteriaInfo[];
    };
}

/**
 * WaitingListLeadProductCriteriaInformationTableV1 displays product criteria
 * information associated with a waiting list lead. It shows values in plain text
 * if the lead is acquired or open (not closed), or masks them otherwise.
 */
function WaitingListLeadProductCriteriaInformationTableV1({
    waitingListLeadCriteriaInfo
}: WaitingListLeadProductCriteriaInformationTableV1Props) {
    if (!waitingListLeadCriteriaInfo) return null;

    const {
        waitingListLeadState,
        isClosedByClient,
        isPersonalProduct,
        productCriteriaList
    } = waitingListLeadCriteriaInfo;

    // Decide whether values should be shown plainly or masked
    function canShow(): boolean {
        const canShow =
            waitingListLeadState === WaitingListLeadState.Acquired ||
            (!isClosedByClient &&
                waitingListLeadState === WaitingListLeadState.Open);

        return canShow;
    }

    const rows: TableRow[] = productCriteriaList.map((criteria) => ({
        fieldName: criteria.criteriaName,
        value: criteria.value,
        isDataShowable: canShow()
    }));

    // Determine the table title using your existing helper
    const tableTitle =
        getModalTextsByProductType(
            isPersonalProduct
        ).approvedStateProductCriteriaDetailsTableHeader;

    // Decide header color (previously "green-box" if acquired & not closed, else "blue-box")
    const isGreenHeader =
        waitingListLeadState === WaitingListLeadState.Acquired &&
        !isClosedByClient;
    const headerColor = isGreenHeader ? "green-box" : "blue-box";

    return (
        <GenericInformationTable
            title={tableTitle}
            rows={rows}
            headerColor={headerColor}
        />
    );
}

export default WaitingListLeadProductCriteriaInformationTableV1;
